(function(Drupal, once) {

  Drupal.behaviors.clinicFinderMapZoom = {

    attach: function(context) {

      once(
          'clinic-finder-map-zoom',
          'body',
          context,
      ).forEach(function() {

        function getVisibleMap() {

          if (
              !Drupal.geolocation ||
              !Drupal.geolocation.maps
          ) {
            return null;
          }

          return Drupal.geolocation.maps.find(function(geoMap) {

            if (!geoMap || !geoMap.googleMap) {
              return false;
            }

            const div = geoMap.googleMap.getDiv();

            return (
                div &&
                div.offsetWidth > 0 &&
                div.offsetHeight > 0
            );

          });

        }

        function fitClinicMarkers() {

          const geoMap = getVisibleMap();

          if (
              !geoMap ||
              !geoMap.mapMarkers
          ) {
            return false;
          }

          const map = geoMap.googleMap;
          const bounds = new google.maps.LatLngBounds();

          let markerCount = 0;

          Object.values(geoMap.mapMarkers).forEach(function(marker) {

            if (
                marker &&
                typeof marker.getPosition === 'function'
            ) {
              const position = marker.getPosition();

              if (position) {
                bounds.extend(position);
                markerCount++;
              }
            }

          });

          if (!markerCount) {
            return false;
          }

          console.log('Clinic map: fitting', markerCount, 'markers.');

          google.maps.event.trigger(map, 'resize');

          map.fitBounds(bounds, 50);

          return true;
        }

        function waitForMarkers(attempt = 0) {

          if (attempt >= 25) {
            console.log('Clinic map: stopped waiting for markers.');
            return;
          }

          if (fitClinicMarkers()) {
            return;
          }

          setTimeout(function() {
            waitForMarkers(attempt + 1);
          }, 200);

        }

        // Run after Views AJAX request.
        jQuery(document).on(
            'ajaxSuccess.clinicFinderMapZoom',
            function() {

              pushFiltersToDataLayer();

              console.log('Clinic map: AJAX success.');

              // Wait for Views/Geolocation to finish updating the map.
              setTimeout(function() {
                waitForMarkers();
              }, 700);

            },
        );

        // Initial page load.
        setTimeout(function() {
          waitForMarkers();
        }, 700);

      });

      /**
       * Push selected Views filters to the dataLayer.
       */
      function pushFiltersToDataLayer() {
        var fieldMap = {
          'Behandlungszone': 'select[name="field_booking_availability_target_id[]"]',
          'Behandlungsart': 'select[name="field_treatments_target_id_1[]"]',
        };

        $.each(fieldMap, function (fieldKey, selector) {
          var $select = $(selector);

          if (!$select.length) {
            return;
          }

          var selectedValues = $select.val() || [];

          if (!Array.isArray(selectedValues)) {
            selectedValues = [selectedValues];
          }

          selectedValues = selectedValues.filter(function (value) {
            return value !== '' && value !== 'All';
          });

          var selectedOptions = selectedValues.map(function (value) {
            var $option = $select.find('option').filter(function () {
              return String(this.value) === String(value);
            }).first();

            return {
              id: String(value),
              name: $option.text().trim()
            };
          });

          window.dataLayer = window.dataLayer || [];

          if (selectedOptions.length) {
            window.dataLayer.push({
              page: '/beratung/spezialisten-finden',
              event: 'filter_selected',
              filter_name: fieldKey,
              filter_ids: selectedOptions.map(function (item) {
                return item.id;
              }).join(', '),
              filter_values: selectedOptions.map(function (item) {
                return item.name;
              }).join(', ')
            });
          }
        });
      }
    },

  };

})(Drupal, once);
